import type { RouteWithGeometry } from '../map/types';
import type { ComputeMethod } from './expense-note/expense-note-context';

interface GetTotalPriceArgs {
	mileageAllowanceAmount: number;
	energyAmount: number;
	includeTolls: boolean;
	includeVignettes: boolean;
	includeEnergy: boolean;
	computeMethod: ComputeMethod;
	routeCosts: RouteWithGeometry['costs'];
}

export function getExpenseNotePrice({
	mileageAllowanceAmount,
	energyAmount,
	includeTolls,
	includeVignettes,
	includeEnergy,
	computeMethod,
	routeCosts,
}: GetTotalPriceArgs) {
	let totalPrice = 0;

	if (includeTolls) {
		totalPrice += routeCosts.tolls.amount;
	}

	if (includeVignettes) {
		totalPrice += routeCosts.vignette.amount;
	}

	if (computeMethod === 'allowance') {
		totalPrice += mileageAllowanceAmount;
	} else if (includeEnergy) {
		totalPrice += energyAmount;
	}

	return totalPrice;
}
